import * as React from 'react';
import cx from 'classnames';
import { Box } from '../../utils/index.js';
export const Label = React.forwardRef((props, forwardedRef) => {
  let {
    displayStyle = 'block',
    required,
    disabled,
    className,
    children,
    ...rest
  } = props;
  return React.createElement(
    Box,
    {
      as: 'label',
      className: cx(
        'iui-input-label',
        {
          'iui-inline': 'inline' === displayStyle,
          'iui-required': required,
        },
        className,
      ),
      'data-iui-disabled': !!disabled || void 0,
      ref: forwardedRef,
      ...rest,
    },
    children,
  );
});
Label.displayName = 'Label';
